export const SOUNDS = [{
    id: 1,
    url: "lee_pissed_on_chicken.mp3",
    series: 1,
    episode: 4,
    person: "captain lee",
    quote: "Pissed on chicken"
},
{
    id: 2,
    url: "lee_get_out_of_way.mp3",
    series: "",
    episode: "",
    person: "captain lee",
    quote: "Get out of the way"
},
 {
    id: 3,
    url: "lee_screwed_the_pooch.mp3",
    series: "",
    episode: "",
    person: "captain lee",
    quote: "Screwed the pooch"
},
 {
    id: 4,
    url: "lee_ha_no.mp3",
    series: "",
    episode: "",
    person: "captain lee",
    quote: "Haha No"
},
 {
    id: 5,
    url: "lee_god_dam_it.mp3",
    series: "",
    episode: "",
    person: "captain lee",
    quote: "God dam it!"
},
{
    id: 6,
    url: "kate_rocket_ship.mp3",
    series: "",
    episode: "",
    person: "chief steward kate",
    quote: "It's a rocket ship"
},
 {
    id: 7,
    url: "ben_laugh.mp3",
    series: "",
    episode: "",
    person: "chef ben",
    quote: "Ben's laugh"
},
{
    id: 8,
    url: "kate_rage_genius.mp3",
    series: "",
    episode: "",
    person: "chief steward Kate",
    quote: "Rage genius"
},
 {
    id: 9,
    url: "kate_i_am_times_new_roman.mp3",
    series: "",
    episode: "",
    person: "chief steward Kate",
    quote: "I am times new roman"
},
  {
    id: 10,
    url: "hannah_are_you_kidding_me.mp3",
    series: "1",
    episode: "8",
    location: "mediterranean",
    person: "chief steward Hannah",
    quote: "Are you kidding me you smurf?"
},
 {
    id: 11,
    url: "guest_foam_is_coming.mp3",
    series: "2",
    episode: "",
    person: "Guest",
    quote: "Foam is coming!"
},
 {
    id: 12,
    url: "eddie_she_came_in_and_seduced_me.mp3",
    series: "3",
    episode: "",
    person: "Bosan Eddie",
    quote: "She came in and seduced me"
}
]